import React from 'react';
import ReactPlayer from 'react-player';

function VimeoPlayer({url}) {
  return (
    <div className="video-responsive">
    <iframe
      src={url}
      frameBorder="1"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded video"
    />
  </div>
  );
}

export default VimeoPlayer;